import React from 'react';
import styled from 'styled-components';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import BoxHeaderIcon from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeaderIcon';
import BoxHeader from '../../../../../../../../components/Layout/Components/Box/Header/BoxHeader';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import CancelIcon from '@material-ui/icons/Cancel';
import Dialog from '../../../../../../../../components/Dialog';
import useDialog from '../../../../../../../../hooks/useDialog';
import { cancelTransactionAction } from '../../../actions';
import PopoverMenu from '../../../../../../../../components/PopoverMenu/PopoverMenu';
import NoteDialog from '../Note/NoteDialog';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';

const HeaderWrapper = styled.div`
  color: #333333;
  display: flex;
  padding: 15px;
`;

const Header = ({ transactionId }) => {
  const linesCount = useSelector((state) => state?.receipt?.lines?.data?.length);
  const dispatch = useDispatch();

  const {
    dialogOpened: cancelDialogOpened,
    closeDialog: closeCancelDialog,
    openDialog: openCancelDialog,
  } = useDialog();

  const {
    dialogOpened: noteDialogOpened,
    closeDialog: closeNoteDialog,
    openDialog: openNoteDialog,
  } = useDialog();

  return (
    <BoxHeader>
      <BoxHeaderIcon color={'#fb8c00'}>
        <div style={{ width: '30px', height: '30px', textAlign: 'center' }}>
          <ShoppingBasketIcon style={{ fontSize: '1.5em' }} />
        </div>
      </BoxHeaderIcon>
      <HeaderWrapper>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          flex: 1,
        }}>
          <FormattedMessage id={'pos.receipt.header.itemsCount'}
                            values={{ itemsCount: linesCount || 0 }} />
          {transactionId !== 'new' &&
          <PopoverMenu icon={<MoreHorizIcon style={{ position: 'absolute' }} />}>
            <ReceiptSubmenuContainer>
              {/*<NoteButton onClick={openNoteDialog}>*/}
              {/*  <CommentOutlinedIcon />*/}
              {/*  <FormattedMessage id={'transaction.editNote'} />*/}
              {/*</NoteButton>*/}
              <CancelButton onClick={openCancelDialog}>
                <CancelIcon />
                <FormattedMessage id={'transaction.cancel'} />
              </CancelButton>
            </ReceiptSubmenuContainer>
          </PopoverMenu>}
        </div>
      </HeaderWrapper>
      <Dialog opened={cancelDialogOpened} onClose={closeCancelDialog}
              onSubmit={() => dispatch(cancelTransactionAction(transactionId))} />
      <NoteDialog open={noteDialogOpened} handleClose={closeNoteDialog} />
    </BoxHeader>
  );
};

export default Header;

const ReceiptSubmenuContainer = styled.div`
  padding: 10px;
`;
const ReceiptSubmenuButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 10px;

  &:hover {
    background-color: #eeeeee;
    cursor: pointer;
  }
`;
const CancelButton = styled(ReceiptSubmenuButton)`
  color: red;

  &:hover {
    background-color: red;
    color: white;
  }
`;

const NoteButton = styled(ReceiptSubmenuButton)`
  
`;

